/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['underscore'], (_) => {
	return class APIContext {
		constructor(options) {
			this.options = options;
			_.extend(this, options);
			this._events = [];
		}

		toJSON() {
			return this.options;
		}

		addEvent(event){
			this._events.push(event);
		}

		getEventList(){
			return this._events;
		}
	};
});
